import { render, staticRenderFns } from "./ListReason.vue?vue&type=template&id=823ef236"
import script from "./ListReason.vue?vue&type=script&lang=js"
export * from "./ListReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListReason.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('823ef236')) {
      api.createRecord('823ef236', component.options)
    } else {
      api.reload('823ef236', component.options)
    }
    module.hot.accept("./ListReason.vue?vue&type=template&id=823ef236", function () {
      api.rerender('823ef236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/views/ListReason.vue"
export default component.exports